// ─── index.js ─────────────────────────────────────────────────────────────────
// Hoofdexport van printUtils.
// PrintDialog.jsx importeert alleen uit dit bestand:
//   import { generateHTML, generateWordHTML } from './printUtils';
// Voeg nieuwe rapporttypes toe door een generator te importeren en
// toe te voegen aan de switch in generateHTML.

import { pageCss, wrapMetHerhalendeHeader } from './layout.js';
import { genDashboard }      from './generators/dashboard.js';
import { genZendingen }      from './generators/zendingen.js';
import { genMaandrapport }   from './generators/maandrapport.js';
import { genJaaroverzicht }  from './generators/jaaroverzicht.js';
import { genZendingDetail }  from './generators/zendingDetail.js';
import { genFacturen }       from './generators/facturen.js';
export { generateWordHTML }  from './word.js';

export function generateHTML(type, aanvragen, facturen, bedrijfsnaam, cfg, forPrint=false, logo=null) {
  switch(type) {
    case 'dashboard':      return genDashboard(aanvragen, bedrijfsnaam, cfg, logo);
    case 'zendingen':      return genZendingen(aanvragen, bedrijfsnaam, cfg, logo);
    case 'maandrapport':   return genMaandrapport(aanvragen, bedrijfsnaam, cfg, logo);
    case 'jaaroverzicht':  return genJaaroverzicht(aanvragen, bedrijfsnaam, cfg, logo);
    case 'zending_detail': return genZendingDetail(aanvragen, bedrijfsnaam, cfg, logo);
    case 'facturen':       return genFacturen(facturen, bedrijfsnaam, cfg, logo);
    default: return '<p>Onbekend rapporttype</p>';
  }
}
